<template>
  <div class="update-adaptive-game-update-video-element container-fluid"> 
    <div id="myNav" class="overlay overlay-overall-width-100Perc">
      <div class="overlay-content center-aligned-div white-porition-overlay-width-80Perc background-color-white margin-bottom-2Perc">
        <div class="row margin-left-1Point5Perc">
          <div class="col-md-7 col-lg-7 text-align-left margin-Top-1Point5Perc create-element-overlay-course-title-font-styles">
            {{getCurrentlySelectedCourseObj.CourseTitle}}
          </div>    
          <div class="col-md-5 col-lg-5">
            <div class="text-right close-text-font-style margin-right-3Perc cursor-pointer" v-on:click="udpateCloseUpdateElementOverlay($event,false)">
              <img src= "../../../assets/images/close.svg" class="img-responsive close-img-width-height margin-top-3Perc float-right" alt="close-icon">
            </div>  
          </div>
        </div>
        <div class="row margin-left-1Point5Perc padding-bottom-1Perc bottom-border margin-bottom-2Perc">
          <div class="col-md-12 col-lg-12 text-align-left font-wight-bold create-element-overlay-module-title-font-styles">
            {{lessonObj.Title}}
          </div>    
        </div>
        <!-- ss: title dummy -->
        <div class="row vertical-align margin-bottom-2Perc">
          <div class="col-md-1 col-lg-1">
          </div>  
          <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
            Title
          </div>
          <div class="col-md-4 col-lg-4">
            <div class="form-group">
              <div class="col-sm-12">
                <input type="text" class="form-control" v-model="VideoTitleValue" :maxlength="maxLength">
              </div>
            </div>
          </div>
          <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
            Audio Url
          </div>
          <div class="col-md-4 col-lg-4">
            <div class="form-group">
              <div class="col-sm-12">
                <input type="text" class="form-control" v-model="AudioURLValue">
              </div>
            </div>
          </div>
          <div class="col-md-1 col-lg-1">
          </div> 
        </div>

        <div class="row vertical-align margin-bottom-2Perc">
          <div class="col-md-1 col-lg-1">
          </div>  
          <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
            Video Url(s)
          </div>
          <div class="col-md-4 col-lg-4">
            <div class="form-group">
              <div class="col-sm-12">
                  <video-quality-control :parentElementObj="elementObj" :currQualityType="constants.Video_Quality.Q_360" :disableInputBox="disableInputBoxFor360And720" @updatedValue="updateVideoQualityValue"></video-quality-control>
                  <video-quality-control :parentElementObj="elementObj" :currQualityType="constants.Video_Quality.Q_Auto" :disableInputBox="false" @updatedValue="updateVideoQualityValue"></video-quality-control>
                  <video-quality-control :parentElementObj="elementObj" :currQualityType="constants.Video_Quality.Q_720" :disableInputBox="disableInputBoxFor360And720" @updatedValue="updateVideoQualityValue"></video-quality-control>
              </div>
            </div>
          </div>
          <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
            Caption File
          </div>
          <div class="col-md-4 col-lg-4">
            <div class="row">
                <div class="col-md-12 col-lg-12">
                  <div class="form-group">
                    <div class="col-sm-12">
                      <input type="file" id="vttFile" accept=".vtt">
                    </div>
                  </div>
                </div>
                <div class="col-md-12 col-lg-12 text-align-left padding-left-22px" v-if="ElementObj.CaptionsFileUrl !== null && ElementObj.CaptionsFileUrl !== '' && ElementObj.CaptionsFileUrl !== 'null' && ElementObj.CaptionsFileUrl !== undefined">
                  <a :href="VTTFileUrl">Download Existing</a>
                </div>
              </div>
          </div>
          <div class="col-md-1 col-lg-1">
          </div> 
        </div>

        <div class="row vertical-align margin-bottom-2Perc">
          <div class="col-md-1 col-lg-1">
          </div>  
          <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
            Content
          </div>
          <div class="col-md-9 col-lg-9">
            <div class="form-group">
              <div class="col-sm-12">
                <tinymce id="d1" v-model="VideoContentValue"></tinymce>
              </div>
            </div>
          </div>
          <div class="col-md-1 col-lg-1">
          </div>  
        </div>
        <div class="row vertical-align margin-bottom-2Perc" v-if="!lessonObj.IsBonusContent">
          <div class="col-md-12 col-lg-12">
            <div class="form-group">
              <div class="checkbox">
                <label><input type="checkbox" value="true" v-model="VideoIncludeInProgress" disabled>Include In Progress</label>
              </div>
            </div>
          </div> 
        </div>
        <div class="row margin-bottom-2Perc">  
          <div class="col-md-4 col-md-offset-4 col-lg-4 col-lg-offset-4">
            <button class="btn btn-primary create-lesson-overlay-button-BG black-font-color" @click="UpdateVideoElement">Update Descriptive Video</button>
          </div>  
          <div class="col-md-4 col-lg-4">
          </div>
        </div>
        <div class="row">
        </div>             
      </div>
    </div>
    <!-- Show Spinner -->
    <div class="animationload" v-show="showSpinner">
      <div class="osahanloading"></div>
    </div> 
    <loader></loader>
    <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
  </div> 
</template>
<script>
import Loader from '@/components/dashboard/Loader'
import { constants } from '@/utils/constants'
import { elementService } from '@/server-util/element-service'
import AlertBox from '@/components/AlertOverlay'
import tinymce from 'vue-tinymce-editor'
import { dmAdminUtils } from '@/utils/dmAdminUtils'
import VideoQualityControl from '@/components/VideoQualityControl'
export default {
  props: ['lessonObj', 'ElementObj'],
  name: 'update-adaptive-game-update-video-element',
  created () {
    this.setDefaultValue()
  },
  data: function () {
    return {
      constants: constants,
      disableInputBoxFor360And720: true,
      showAlertDialog: false,
      errorMsg: '',
      elementObj: {
        ElementId: '',
        ModuleId: '',
        Title: '',
        Duration: '',
        Type: 9,
        VideoUrl: '',
        AudioUrl: '',
        Content: null,
        Index: null,
        RDType: null,
        IncludeInProgress: true,
        LinkText: null,
        FileUrl: null,
        ElemChallenge: null,
        IsDescriptive: true,
        Description: '',
        CaptionsFileUrl: null,
        LowQualityVideoUrl: '',
        HDVideoUrl: ''
      },
      showSpinner: false,
      maxLength: constants.Element_Title_Step_Max_Length
    }
  },
  components: {
    'alert-box': AlertBox,
    'loader': Loader,
    'tinymce': tinymce,
    'video-quality-control': VideoQualityControl
  },
  methods: {
    udpateCloseUpdateElementOverlay: function (event) {
      var objToPass = {
        closeOverlay: true,
        refreshList: false,
        updatedObj: null
      }
      this.$emit('closeUpdateVideoOverlay', objToPass)
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    chekcToolkitFileExtesion: function (fileName) {
      var exts = ['.pdf']
      return new RegExp('(' + exts.join('|').replace(/\./g, '\\.') + ')$').test(
        fileName
      )
    },
    updateVideoQualityValue (value) {
      console.log('Emitted with: ', value)
      const videoUrl = value.videoUrl
      const currQualityType = value.currQualityType
      switch (parseInt(currQualityType)) {
        case parseInt(constants.Video_Quality.Q_360):
          console.log('360 ' + videoUrl)
          this.elementObj.LowQualityVideoUrl = videoUrl
          break
        default:
        case parseInt(constants.Video_Quality.Q_Auto):
          console.log('Auto ' + videoUrl)
          this.elementObj.VideoUrl = videoUrl
          if (this.elementObj.VideoUrl.trim().length === 0) {
            this.elementObj.LowQualityVideoUrl = ''
            this.elementObj.HDVideoUrl = ''
            this.disableInputBoxFor360And720 = true
          } else {
            this.disableInputBoxFor360And720 = false
          }
          break
        case parseInt(constants.Video_Quality.Q_720):
          console.log('720 ' + videoUrl)
          this.elementObj.HDVideoUrl = videoUrl
          break
      }
    },
    UpdateVideoElement: function (event) {
      var vttFileUrl = document.getElementById('vttFile').files[0]
      if (this.validateRequiredFieldBeforeSubmit()) {
        if (vttFileUrl === undefined && vttFileUrl === null) {
          vttFileUrl = null
        }
        this.VideoDurationValue = parseInt(document.getElementById('videoTag').duration)
        const formData = new FormData()
        formData.append('ModuleId', this.elementObj.ModuleId)
        formData.append('ElementId', this.elementObj.ElementId)
        formData.append('Title', this.elementObj.Title)
        const videoUrl = this.elementObj.VideoUrl !== '' ? this.elementObj.VideoUrl.trim() : ''
        formData.append('VideoUrl', videoUrl)
        const hdVideoUrl = this.elementObj.HDVideoUrl !== '' ? this.elementObj.HDVideoUrl.trim() : ''
        formData.append('HDVideoUrl', hdVideoUrl)
        const lowVideoUrl = this.elementObj.LowQualityVideoUrl !== '' ? this.elementObj.LowQualityVideoUrl.trim() : ''
        formData.append('LowQualityVideoUrl', lowVideoUrl)
        const audioUrl = this.elementObj.AudioUrl !== '' ? this.elementObj.AudioUrl.trim() : null
        formData.append('AudioUrl', audioUrl)
        formData.append('Duration', this.elementObj.Duration)
        formData.append('IsDescriptive', this.elementObj.IsDescriptive)
        formData.append('Description', this.elementObj.Description)
        if (this.elementObj.Index !== null && this.elementObj.Index !== '') {
          formData.append('Index', parseInt(this.elementObj.Index))
        }
        formData.append('VttFileInput', vttFileUrl)
        formData.append('IncludeInProgress', this.elementObj.IncludeInProgress)
        var _this = this
        var storeObj = this.$store
        if (formData !== undefined && formData !== '' && formData !== undefined) {
          _this.$store.state.isLoading = true
          const orgContent = dmAdminUtils.removeTFromUrls(_this.elementObj.Description)
          _this.elementObj.Description = orgContent
          elementService
            .updateVideoElement(storeObj.state.access_token, formData)
            .then(
              responseObj => {
                if (responseObj.status >= 200 && responseObj.status < 300) {
                  var objToPass = {
                    closeOverlay: true,
                    refreshList: true,
                    updatedObj: responseObj.data
                  }
                  _this.$emit('closeUpdateVideoOverlay', objToPass)
                  _this.$store.state.isLoading = false
                } else {
                  // AK: Hide Spinner
                  // _this.showSpinner = false
                  _this.$store.state.isLoading = false
                  this.showAlertDialog = true
                  this.errorMsg =
                    'Oops! Something went wrong. Please try again.'
                }
              },
              errorObj => {
                // AK: Hide Spinner
                // _this.showSpinner = false
                _this.$store.state.isLoading = false
                this.showAlertDialog = true
                if (errorObj.response === undefined) {
                  this.errorMsg = constants.No_Internet_Connection_Msg
                } else {
                  this.errorMsg = errorObj.response.statusText
                }
              }
            )
        } else {
          console.log(
            'Selected FormData is NULL hence declined ALG UPDATE VIDEO OPERATION'
          )
        }
      }
    },
    setDefaultValue: function () {
      console.log(JSON.stringify(this.ElementObj))
      this.elementObj.ModuleId = this.ElementObj.ModuleId
      this.elementObj.ElementId = this.ElementObj.ElementId
      this.elementObj.Index = this.ElementObj.Index
      this.elementObj.Title = this.ElementObj.Title
      this.elementObj.Duration = this.ElementObj.Duration
      this.elementObj.AudioUrl = (this.ElementObj.AudioUrl !== null && this.ElementObj.AudioUrl !== 'null' && this.ElementObj.AudioUrl !== undefined) ? this.ElementObj.AudioUrl : ''
      this.elementObj.LowQualityVideoUrl = (this.ElementObj.LowQualityVideoUrl !== undefined && this.ElementObj.LowQualityVideoUrl !== 'undefined' && this.ElementObj.LowQualityVideoUrl !== null && this.ElementObj.LowQualityVideoUrl !== 'null' && this.ElementObj.LowQualityVideoUrl !== '') ? this.ElementObj.LowQualityVideoUrl : ''
      this.elementObj.HDVideoUrl = (this.ElementObj.HDVideoUrl !== undefined && this.ElementObj.HDVideoUrl !== 'undefined' && this.ElementObj.HDVideoUrl !== null && this.ElementObj.HDVideoUrl !== 'null' && this.ElementObj.HDVideoUrl !== '') ? this.ElementObj.HDVideoUrl : ''
      this.elementObj.VideoUrl = (this.ElementObj.VideoUrl !== undefined && this.ElementObj.VideoUrl !== 'undefined' && this.ElementObj.VideoUrl !== null && this.ElementObj.VideoUrl !== 'null' && this.ElementObj.VideoUrl !== '') ? this.ElementObj.VideoUrl : ''
      this.disableInputBoxFor360And720 = this.ElementObj.VideoUrl.trim().length === 0
      this.elementObj.LinkText = this.ElementObj.LinkText
      this.elementObj.FileUrl = this.ElementObj.FileUrl
      this.elementObj.IncludeInProgress = this.ElementObj.IncludeInProgress
      this.elementObj.IsDescriptive = this.ElementObj.IsDescriptive
      this.elementObj.CaptionsFileUrl = this.ElementObj.CaptionsFileUrl
      var _this = this
      setTimeout(function () {
        _this.elementObj.Description = dmAdminUtils.updateUrls(_this.ElementObj.Description)
      }, 500)
    },
    stripHtml: function (html) {
      // Create a new div element
      var temporalDivElement = document.createElement('div')
      // Set the HTML content with the providen
      temporalDivElement.innerHTML = html
      // Retrieve the text property of the element (cross-browser support)
      return temporalDivElement.textContent || temporalDivElement.innerText || ''
    },
    validateRequiredFieldBeforeSubmit: function () {
      var vttFileUrl = document.getElementById('vttFile').files[0]
      if (this.VideoTitleValue.trim().length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Title can\'t be empty.'
        this.elementObj.Title = this.ElementObj.Title
        return false
      } else if (this.AudioURLValue.trim().length !== 0 && (!dmAdminUtils.isValidUrl(this.AudioURLValue.trim()) || !dmAdminUtils.checkForAudioFileExtesion(this.AudioURLValue.trim()))) {
        this.showAlertDialog = true
        this.errorMsg = 'Please add valid Audio url.'
        return false
      } else if (this.LowVideoURLValue.trim().length !== 0 && (!dmAdminUtils.isValidUrl(this.LowVideoURLValue.trim()) || !dmAdminUtils.checkForVideoFileExtesion(this.LowVideoURLValue.trim()))) {
        this.showAlertDialog = true
        this.errorMsg = 'Please add valid Low Quality Video url.'
        return false
      } else if (this.VideoURLValue.trim().length === 0 || !dmAdminUtils.isValidUrl(this.VideoURLValue.trim()) || !dmAdminUtils.checkForVideoFileExtesion(this.VideoURLValue.trim())) {
        this.showAlertDialog = true
        this.errorMsg = 'Please add valid Auto Quality Video url.'
        return false
      } else if (this.HDVideoURLValue.trim().length !== 0 && (!dmAdminUtils.isValidUrl(this.HDVideoURLValue.trim()) || !dmAdminUtils.checkForVideoFileExtesion(this.HDVideoURLValue.trim()))) {
        this.showAlertDialog = true
        this.errorMsg = 'Please add valid High Quality Video url.'
        return false
      } else if (vttFileUrl !== undefined && vttFileUrl !== null && !this.checkVttFileExtesion(document.getElementById('vttFile').value)) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select a valid .vtt file for caption.'
        return false
      }
      return true
    },
    checkVttFileExtesion: function (fileName) {
      var exts = ['.vtt']
      return new RegExp('(' + exts.join('|').replace(/\./g, '\\.') + ')$').test(
        fileName
      )
    }
  },
  computed: {
    VideoContentValue: {
      get: function () {
        return this.elementObj.Description
      },
      set: function (newValue) {
        this.elementObj.Description = newValue
      }
    },
    getCurrentlySelectedCourseObj: {
      get: function () {
        return this.$store.state.selectedCourseObjFromFilter
      }
    },
    VideoTitleValue: {
      get: function () {
        return this.elementObj.Title
      },
      set: function (newValue) {
        this.elementObj.Title = newValue
      }
    },
    VideoIndexValue: {
      get: function () {
        return this.elementObj.Index
      },
      set: function (newValue) {
        if (newValue.trim() !== '') {
          var isNonNumeric = /[^$,.\d]/
          var nonNumericResult = newValue.match(isNonNumeric)
          if (!nonNumericResult) {
            if (parseInt(newValue) >= 1000) {
              this.errorMsg = 'Index should be less than 1000.'
              this.showAlertDialog = true
              this.elementObj.Index = this.ElementObj.Index
            } else {
              this.elementObj.Index = parseInt(newValue)
            }
          } else {
            this.showAlertDialog = true
            this.errorMsg = 'Index must be a positive numeric value.'
            this.elementObj.Index = this.ElementObj.Index
          }
        } else {
          this.elementObj.Index = null
        }
      }
    },
    VideoDurationValue: {
      get: function () {
        return this.elementObj.Duration
      },
      set: function (newValue) {
        this.elementObj.Duration = newValue
      }
    },
    VideoLinkTextValue: {
      get: function () {
        return this.elementObj.LinkText === null || this.elementObj.LinkText === 'null' ? '' : this.elementObj.LinkText
      },
      set: function (newValue) {
        this.elementObj.LinkText = newValue
      }
    },
    VideoIncludeInProgress: {
      get: function () {
        return this.elementObj.IncludeInProgress
      },
      set: function (newValue) {
        this.elementObj.IncludeInProgress = newValue
      }
    },
    VideoPDFUrl: {
      get: function () {
        return this.elementObj.FileUrl
      }
    },
    VTTFileUrl: {
      get: function () {
        return this.elementObj.CaptionsFileUrl
      }
    },
    VideoURLValue: {
      get: function () {
        return this.elementObj.VideoUrl
      },
      set: function (newValue) {
        this.elementObj.VideoUrl = newValue
      }
    },
    HDVideoURLValue: {
      get: function () {
        return this.elementObj.HDVideoUrl
      },
      set: function (newValue) {
        this.elementObj.HDVideoUrl = newValue
      }
    },
    LowVideoURLValue: {
      get: function () {
        return this.elementObj.LowQualityVideoUrl
      },
      set: function (newValue) {
        this.elementObj.LowQualityVideoUrl = newValue
      }
    },
    AudioURLValue: {
      get: function () {
        return this.elementObj.AudioUrl
      },
      set: function (newValue) {
        this.elementObj.AudioUrl = newValue
      }
    }
  }
}
</script>

<style scoped>
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.white-BG {
  background-color: #ffffff;
}
.overlay-overall-width-100Perc {
  width: 100% !important;
}
.overlay-overall-width-0Perc {
  width: 0%;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.75);
  overflow-x: hidden;
  /*transition: 0.5s;*/
}

.overlay-content {
  position: relative;
  top: 8%;
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.background-color-white {
  background-color: #ffffff !important;
}
.white-porition-overlay-width-80Perc {
  width: 80%;
}
.center-aligned-div {
  margin: 0 auto;
}

.overlay a {
  padding: 8px;
  text-decoration: none;
  font-size: 36px;
  color: #818181;
  display: block;
  transition: 0.3s;
}

.overlay a:hover,
.overlay a:focus {
  color: #f1f1f1;
}

.overlay .closebtn {
  position: absolute;
  top: 20px;
  right: 45px;
  font-size: 60px;
}
@media screen and (max-height: 450px) {
  .overlay a {
    font-size: 20px;
  }
  .overlay .closebtn {
    font-size: 40px;
    top: 15px;
    right: 35px;
  }
}
.close-text-font-style {
  color: #aaa;
  font-size: 30px;
}
.text-align-right {
  text-align: right;
}
.margin-right-2Perc {
  margin-right: 2%;
}
.width {
  width: 95%;
}
.create-lesson {
  overflow-y: hidden !important;
}
.background-gray {
  background-color: aqua;
}
.overflow-y-hidden {
  overflow-y: hidden !important;
}
.overflow-hidden {
  overflow: hidden;
}
.save-button-width {
  width: 60% !important;
}
.padding-Top-2Perc {
  padding-top: 2%;
}
.padding-Top-3Perc {
  padding-top: 3%;
}
.font-size-1-3vw {
  font-size: 1.3vw;
}
.font-size-21px {
  font-size: 21px;
}
.text-align-left {
  text-align: left;
}
.input-group .icon-addon .form-control {
  border-radius: 0;
}

.icon-addon {
  position: relative;
  color: #555;
  display: block;
}

.icon-addon:after,
.icon-addon:before {
  display: table;
  content: " ";
}

.icon-addon:after {
  clear: both;
}

.icon-addon.addon-md .glyphicon,
.icon-addon .glyphicon,
.icon-addon.addon-md .fa,
.icon-addon .fa {
  position: absolute;
  z-index: 2;
  left: 10px;
  font-size: 14px;
  width: 20px;
  margin-left: -2.5px;
  text-align: center;
  padding: 8px 0;
  top: 1px;
}

.icon-addon.addon-lg .form-control {
  line-height: 1.33;
  height: 30px;
  border-radius: 15px;
  font-size: 13px;
  padding: 10px 16px 10px 40px;
}

.icon-addon.addon-sm .form-control {
  height: 30px;
  padding: 5px 10px 5px 28px;
  font-size: 12px;
  line-height: 1.5;
}

.icon-addon.addon-lg .fa,
.icon-addon.addon-lg .glyphicon {
  font-size: 14px;
  margin-left: 0;
  left: 11px;
  top: 0px;
}

.icon-addon.addon-md .form-control,
.icon-addon .form-control {
  padding-left: 30px;
  float: left;
  font-weight: normal;
}

.icon-addon.addon-sm .fa,
.icon-addon.addon-sm .glyphicon {
  margin-left: 0;
  font-size: 12px;
  left: 5px;
  top: -1px;
}

.icon-addon .form-control:focus + .glyphicon,
.icon-addon:hover .glyphicon,
.icon-addon .form-control:focus + .fa,
.icon-addon:hover .fa {
  color: #2580db;
}
.background-gray {
  background-color: #ddd;
}
.border-rounded {
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}
.gray-border {
  border: 1px solid #aaa;
}
.lesson-box-border {
  border: 1px solid #dddddd;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.center-align-div {
  margin: 0 auto;
}
.margin-left-3Perc {
  margin-left: 3% !important;
}
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
}

.switch input {
  display: none;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 23px;
  width: 23px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #32cd32;
}

input:focus + .slider {
  box-shadow: 0 0 1px #32cd32;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
.border-color-red {
  border: 1px solid red;
}
.border-color-yellow {
  border: 1px solid yellow;
}
.create-lesson-input-text-style {
  color: #34495e;
  font-size: 14px;
}
.padding-right-0Px {
  padding-right: 0px !important;
}
.margin-bottom-0Perc {
  margin-bottom: 0%;
}
.margin-bottom-1Perc {
  margin-bottom: 1%;
}
.margin-bottom-2Perc {
  margin-bottom: 2%;
}
.create-lesson-overlay-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.create-lesson-overlay-button-width {
  width: 20%;
}
.black-font-color {
  color: #000;
}
.cursor-pointer {
  cursor: pointer;
}
.close-img-width-height {
  width: 5%;
  height: 5%;
}
.margin-top-3Perc {
  margin-top: 3%;
}
.float-right {
  float: right;
}
.font-color-blue {
  color: #34495e;
}
.font-weight-bold {
  font-weight: bold;
}

.margin-right-3Perc {
  margin-right: 3%;
}
.margin-left-2Perc {
  margin-left: 2% !important;
}
.padding-bottom-1Perc {
  padding-bottom: 1%;
}
.bottom-border {
  border-bottom: 1px solid #ddd;
  width: 96%;
}
.font-wight-bold {
  font-weight: bold;
}
.create-element-overlay-course-title-font-styles {
  font-size: 14px;
  color: #34495e;
}
.create-element-overlay-module-title-font-styles {
  font-size: 20px;
  color: #34495e;
}
.margin-Top-1Point5Perc {
  padding-top: 1.5%;
}
.padding-left-4Point4 {
  padding-left: 4.4%;
}
a:link{
  color: #0000FF !important;
  text-decoration: none !important;
} 
a:visited{
  color: #0000FF !important;
  text-decoration: none !important;
}
a:hover{
  color: #0000FF !important;
  text-decoration: underline !important;
}
a:active{
  color: #0000FF !important;
  text-decoration: none !important;
}
a {
  color: #0000FF !important;
  text-decoration: none !important;
}
a {
  font-size: 14px !important;
}
.create-lesson-label-text-style {
  color: #34495e;
  font-size: 12px;
}
.margin-left-1Point5Perc
{
  margin-left:1.5%;
}
.border-red{
  border: 1px solid red;
}
.padding-left-right-2Perc {
  padding-left: 2%;
  padding-right: 2%;
}
.padding-left-5Perc {
  padding-left: 5%;
}
.padding-left-4Perc {
  padding-left: 4%;
}
.audio-width {
  width: -webkit-fill-available;
}
.padding-left-right-30px {
  padding-left: 30px;
  padding-right: 30px;
}
.blueColor {
  color: #337ab7;
}
.margin-right-15px {
  margin-right: 15px;
}
.text-align-center {
  text-align: center;
}
.opacity0Point5 {
  opacity: 0.5;
}
.orangeColor {
  color: #f39c12;
}
</style>


// WEBPACK FOOTER //
// src/components/adaptive_game/Update-element/UpdateAdaptiveGameUpdateVideoElement.vue